import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "hidden 2xl:block overflow-x-auto" }
const _hoisted_2 = { class: "min-w-full divide-y divide-gray-200 dark:divide-gray-700" }
const _hoisted_3 = { class: "bg-white dark:bg-black divide-y divide-gray-200 dark:divide-gray-700" }
const _hoisted_4 = { class: "px-3 sm:px-6 py-4 whitespace-nowrap text-sm text-center" }
const _hoisted_5 = { class: "text-xs sm:text-sm text-gray-900 dark:text-white font-medium" }
const _hoisted_6 = { class: "px-3 sm:px-6 py-4 whitespace-nowrap text-sm text-center" }
const _hoisted_7 = { class: "px-3 sm:px-6 py-4 text-sm text-center text-gray-900 dark:text-white" }
const _hoisted_8 = { class: "font-medium text-xs sm:text-sm" }
const _hoisted_9 = { class: "text-xs text-gray-500 dark:text-gray-400" }
const _hoisted_10 = { class: "px-3 sm:px-6 py-4 text-sm text-center text-gray-900 dark:text-white" }
const _hoisted_11 = { class: "font-medium text-xs sm:text-sm" }
const _hoisted_12 = { class: "text-xs text-gray-500 dark:text-gray-400" }
const _hoisted_13 = { class: "text-xs text-gray-500 dark:text-gray-400" }
const _hoisted_14 = { class: "px-3 sm:px-6 py-4 text-sm text-center text-gray-900 dark:text-white" }
const _hoisted_15 = { class: "text-xs sm:text-sm" }
const _hoisted_16 = { class: "text-xs text-gray-500 dark:text-gray-400" }
const _hoisted_17 = { class: "px-3 sm:px-6 py-4 whitespace-nowrap text-sm text-center" }
const _hoisted_18 = { class: "text-xs sm:text-sm text-gray-500 dark:text-gray-400" }
const _hoisted_19 = { class: "px-3 sm:px-6 py-4 whitespace-nowrap text-center" }
const _hoisted_20 = { class: "px-3 sm:px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400 text-center" }
const _hoisted_21 = { class: "flex items-center justify-center space-x-1 lg:space-x-2" }
const _hoisted_22 = { class: "relative group inline-block" }
const _hoisted_23 = ["onClick", "disabled"]
const _hoisted_24 = { class: "relative group inline-block" }
const _hoisted_25 = ["onClick", "disabled"]
const _hoisted_26 = {
  key: 0,
  class: "relative group inline-block"
}
const _hoisted_27 = ["onClick", "disabled"]
const _hoisted_28 = {
  key: 1,
  class: "relative group inline-block"
}
const _hoisted_29 = ["onClick", "disabled"]
const _hoisted_30 = { class: "relative group inline-block" }
const _hoisted_31 = ["onClick", "disabled"]
const _hoisted_32 = { class: "block 2xl:hidden" }
const _hoisted_33 = { class: "divide-y divide-gray-200 dark:divide-gray-700" }
const _hoisted_34 = { class: "flex items-start justify-between mb-4" }
const _hoisted_35 = { class: "flex-1" }
const _hoisted_36 = { class: "text-sm font-semibold text-gray-900 dark:text-white mb-1" }
const _hoisted_37 = { class: "text-xs text-gray-500 dark:text-gray-400" }
const _hoisted_38 = { class: "space-y-2 mb-4" }
const _hoisted_39 = { class: "flex justify-between text-sm" }
const _hoisted_40 = { class: "flex justify-between text-sm" }
const _hoisted_41 = { class: "font-medium text-gray-900 dark:text-white" }
const _hoisted_42 = { class: "flex justify-between text-sm" }
const _hoisted_43 = { class: "font-medium text-gray-900 dark:text-white" }
const _hoisted_44 = { class: "flex justify-between text-sm" }
const _hoisted_45 = { class: "font-medium text-gray-900 dark:text-white" }
const _hoisted_46 = { class: "flex justify-between text-sm" }
const _hoisted_47 = { class: "font-medium text-gray-900 dark:text-white" }
const _hoisted_48 = { class: "flex justify-between text-sm" }
const _hoisted_49 = { class: "font-medium text-gray-900 dark:text-white" }
const _hoisted_50 = { class: "flex justify-between text-sm" }
const _hoisted_51 = { class: "text-gray-900 dark:text-white text-xs" }
const _hoisted_52 = { class: "flex gap-2 pt-3 border-t border-gray-200 dark:border-gray-700" }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = ["onClick"]
const _hoisted_55 = ["onClick"]
const _hoisted_56 = ["onClick"]
const _hoisted_57 = ["onClick"]

import type { Tire } from '@/types/tire';


export default /*@__PURE__*/_defineComponent({
  __name: 'TireApprovalTable',
  props: {
    tires: {},
    loading: { type: Boolean }
  },
  emits: ["approve", "reject", "view", "edit", "delete"],
  setup(__props: any) {





function getBrandClass(brandName?: string): string {
  if (brandName === 'Continental') {
    return 'bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-300';
  } else if (brandName === 'Falken') {
    return 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300';
  }
  return 'bg-gray-100 text-gray-800 dark:bg-gray-900/30 dark:text-gray-300';
}

function getStatusClass(status: string): string {
  switch (status) {
    case 'pending':
      return 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-300';
    case 'approved':
      return 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300';
    case 'rejected':
      return 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300';
    default:
      return 'bg-gray-100 text-gray-800 dark:bg-black/30 dark:text-gray-400';
  }
}

function getStatusDotClass(status: string): string {
  switch (status) {
    case 'pending':
      return 'bg-yellow-500 dark:bg-yellow-400';
    case 'approved':
      return 'bg-green-500 dark:bg-green-400';
    case 'rejected':
      return 'bg-red-500 dark:bg-red-400';
    default:
      return 'bg-gray-500 dark:bg-gray-400';
  }
}

function formatDate(dateString: string): string {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("table", _hoisted_2, [
        _cache[10] || (_cache[10] = _createElementVNode("thead", { class: "bg-gray-50 dark:bg-black" }, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", {
              scope: "col",
              class: "px-3 sm:px-6 py-4 text-center text-xs font-bold text-slate-800 dark:text-gray-400 uppercase tracking-wider"
            }, " Customer "),
            _createElementVNode("th", {
              scope: "col",
              class: "px-3 sm:px-6 py-4 text-center text-xs font-bold text-slate-800 dark:text-gray-400 uppercase tracking-wider"
            }, " Brand "),
            _createElementVNode("th", {
              scope: "col",
              class: "px-3 sm:px-6 py-4 text-center text-xs font-bold text-slate-800 dark:text-gray-400 uppercase tracking-wider"
            }, " Vehicle "),
            _createElementVNode("th", {
              scope: "col",
              class: "px-3 sm:px-6 py-4 text-center text-xs font-bold text-slate-800 dark:text-gray-400 uppercase tracking-wider"
            }, " Tire Details "),
            _createElementVNode("th", {
              scope: "col",
              class: "px-3 sm:px-6 py-4 text-center text-xs font-bold text-slate-800 dark:text-gray-400 uppercase tracking-wider"
            }, " Shop/Invoice "),
            _createElementVNode("th", {
              scope: "col",
              class: "px-3 sm:px-6 py-4 text-center text-xs font-bold text-slate-800 dark:text-gray-400 uppercase tracking-wider"
            }, " Submitted "),
            _createElementVNode("th", {
              scope: "col",
              class: "px-3 sm:px-6 py-4 text-center text-xs font-bold text-slate-800 dark:text-gray-400 uppercase tracking-wider"
            }, " Status "),
            _createElementVNode("th", {
              scope: "col",
              class: "px-3 sm:px-6 py-4 text-center text-xs font-bold text-slate-800 dark:text-gray-400 uppercase tracking-wider"
            }, " Actions ")
          ])
        ], -1)),
        _createElementVNode("tbody", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tires, (tire) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: tire.tire_id,
              class: "transition-colors duration-150 hover:bg-gray-50 dark:hover:bg-gray-600 odd:bg-white even:bg-gray-25 dark:odd:bg-gray-900 dark:even:bg-gray-800"
            }, [
              _createElementVNode("td", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(tire.user?.first_name) + " " + _toDisplayString(tire.user?.last_name), 1)
              ]),
              _createElementVNode("td", _hoisted_6, [
                _createElementVNode("span", {
                  class: _normalizeClass(["inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium", getBrandClass(tire.brand?.brand_name)])
                }, _toDisplayString(tire.brand?.brand_name || 'N/A'), 3)
              ]),
              _createElementVNode("td", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(tire.vehicle?.vehicle_make) + " " + _toDisplayString(tire.vehicle?.vehicle_model), 1),
                _createElementVNode("div", _hoisted_9, _toDisplayString(tire.vehicle?.plate_number), 1)
              ]),
              _createElementVNode("td", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, _toDisplayString(tire.pattern), 1),
                _createElementVNode("div", _hoisted_12, _toDisplayString(tire.tire_size), 1),
                _createElementVNode("div", _hoisted_13, "DOT: " + _toDisplayString(tire.dot), 1)
              ]),
              _createElementVNode("td", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, _toDisplayString(tire.shop), 1),
                _createElementVNode("div", _hoisted_16, _toDisplayString(tire.invoice_number), 1)
              ]),
              _createElementVNode("td", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, _toDisplayString(formatDate(tire.created_at)), 1)
              ]),
              _createElementVNode("td", _hoisted_19, [
                _createElementVNode("span", {
                  class: _normalizeClass(["inline-flex items-center px-2 sm:px-2.5 py-1 rounded-full text-xs font-medium", getStatusClass(tire.approval_status)])
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["w-1.5 h-1.5 rounded-full mr-1 sm:mr-1.5", getStatusDotClass(tire.approval_status)])
                  }, null, 2),
                  _createTextVNode(" " + _toDisplayString(tire.approval_status), 1)
                ], 2)
              ]),
              _createElementVNode("td", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("button", {
                      onClick: _withModifiers(($event: any) => (_ctx.$emit('view', tire)), ["stop"]),
                      disabled: _ctx.loading,
                      class: "inline-flex items-center p-1.5 border border-transparent rounded-md text-blue-600 dark:text-blue-400 hover:bg-blue-50 dark:hover:bg-blue-900/20 transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed"
                    }, _cache[0] || (_cache[0] = [
                      _createElementVNode("svg", {
                        class: "h-5 w-5",
                        fill: "currentColor",
                        viewBox: "0 0 20 20"
                      }, [
                        _createElementVNode("path", { d: "M10 12a2 2 0 100-4 2 2 0 000 4z" }),
                        _createElementVNode("path", {
                          "fill-rule": "evenodd",
                          d: "M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z",
                          "clip-rule": "evenodd"
                        })
                      ], -1)
                    ]), 8, _hoisted_23),
                    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "absolute bottom-full left-1/2 -translate-x-1/2 mb-1 w-max text-xs text-white bg-gray-800 px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition pointer-events-none z-10" }, " View Details ", -1))
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("button", {
                      onClick: _withModifiers(($event: any) => (_ctx.$emit('edit', tire)), ["stop"]),
                      disabled: _ctx.loading,
                      class: "inline-flex items-center p-1.5 border border-transparent rounded-md text-amber-600 dark:text-amber-400 hover:bg-amber-50 dark:hover:bg-amber-900/20 transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed"
                    }, _cache[2] || (_cache[2] = [
                      _createElementVNode("svg", {
                        class: "h-5 w-5",
                        fill: "currentColor",
                        viewBox: "0 0 20 20"
                      }, [
                        _createElementVNode("path", { d: "M17.414 2.586a2 2 0 010 2.828L8 14.828 4 16l1.172-4 9.414-9.414a2 2 0 012.828 0z" })
                      ], -1)
                    ]), 8, _hoisted_25),
                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "absolute bottom-full left-1/2 -translate-x-1/2 mb-1 w-max text-xs text-white bg-gray-800 px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition pointer-events-none z-10" }, " Edit Tire ", -1))
                  ]),
                  (tire.approval_status === 'pending')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _createElementVNode("button", {
                          onClick: _withModifiers(($event: any) => (_ctx.$emit('approve', tire)), ["stop"]),
                          disabled: _ctx.loading,
                          class: "inline-flex items-center p-1.5 border border-transparent rounded-md text-green-600 dark:text-green-400 hover:bg-green-50 dark:hover:bg-green-900/20 transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed"
                        }, _cache[4] || (_cache[4] = [
                          _createElementVNode("svg", {
                            class: "h-5 w-5",
                            fill: "currentColor",
                            viewBox: "0 0 20 20"
                          }, [
                            _createElementVNode("path", {
                              "fill-rule": "evenodd",
                              d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
                              "clip-rule": "evenodd"
                            })
                          ], -1)
                        ]), 8, _hoisted_27),
                        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "absolute bottom-full left-1/2 -translate-x-1/2 mb-1 w-max text-xs text-white bg-gray-800 px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition pointer-events-none z-10" }, " Approve Tire ", -1))
                      ]))
                    : _createCommentVNode("", true),
                  (tire.approval_status === 'pending')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _createElementVNode("button", {
                          onClick: _withModifiers(($event: any) => (_ctx.$emit('reject', tire)), ["stop"]),
                          disabled: _ctx.loading,
                          class: "inline-flex items-center p-1.5 border border-transparent rounded-md text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed"
                        }, _cache[6] || (_cache[6] = [
                          _createElementVNode("svg", {
                            class: "h-5 w-5",
                            fill: "currentColor",
                            viewBox: "0 0 20 20"
                          }, [
                            _createElementVNode("path", {
                              "fill-rule": "evenodd",
                              d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                              "clip-rule": "evenodd"
                            })
                          ], -1)
                        ]), 8, _hoisted_29),
                        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "absolute bottom-full left-1/2 -translate-x-1/2 mb-1 w-max text-xs text-white bg-gray-800 px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition pointer-events-none z-10" }, " Reject Tire ", -1))
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("button", {
                      onClick: _withModifiers(($event: any) => (_ctx.$emit('delete', tire)), ["stop"]),
                      disabled: _ctx.loading,
                      class: "inline-flex items-center p-1.5 border border-transparent rounded-md text-red-700 dark:text-red-500 hover:bg-red-100 dark:hover:bg-red-900/30 transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed"
                    }, _cache[8] || (_cache[8] = [
                      _createElementVNode("svg", {
                        class: "h-5 w-5",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                        })
                      ], -1)
                    ]), 8, _hoisted_31),
                    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "absolute bottom-full left-1/2 -translate-x-1/2 mb-1 w-max text-xs text-white bg-gray-800 px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition pointer-events-none z-10" }, " Delete Tire ", -1))
                  ])
                ])
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("div", _hoisted_33, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tires, (tire) => {
          return (_openBlock(), _createElementBlock("div", {
            key: tire.tire_id,
            class: "p-4 sm:p-6 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors duration-150"
          }, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("h3", _hoisted_36, _toDisplayString(tire.user?.first_name) + " " + _toDisplayString(tire.user?.last_name), 1),
                _createElementVNode("p", _hoisted_37, _toDisplayString(tire.vehicle?.vehicle_make) + " " + _toDisplayString(tire.vehicle?.vehicle_model) + " - " + _toDisplayString(tire.vehicle?.plate_number), 1)
              ]),
              _createElementVNode("span", {
                class: _normalizeClass(["inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ml-2", getStatusClass(tire.approval_status)])
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(["w-1.5 h-1.5 rounded-full mr-1", getStatusDotClass(tire.approval_status)])
                }, null, 2),
                _createTextVNode(" " + _toDisplayString(tire.approval_status), 1)
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "Brand:", -1)),
                _createElementVNode("span", {
                  class: _normalizeClass(["inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium", getBrandClass(tire.brand?.brand_name)])
                }, _toDisplayString(tire.brand?.brand_name || 'N/A'), 3)
              ]),
              _createElementVNode("div", _hoisted_40, [
                _cache[12] || (_cache[12] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "Pattern:", -1)),
                _createElementVNode("span", _hoisted_41, _toDisplayString(tire.pattern), 1)
              ]),
              _createElementVNode("div", _hoisted_42, [
                _cache[13] || (_cache[13] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "Size:", -1)),
                _createElementVNode("span", _hoisted_43, _toDisplayString(tire.tire_size), 1)
              ]),
              _createElementVNode("div", _hoisted_44, [
                _cache[14] || (_cache[14] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "DOT:", -1)),
                _createElementVNode("span", _hoisted_45, _toDisplayString(tire.dot), 1)
              ]),
              _createElementVNode("div", _hoisted_46, [
                _cache[15] || (_cache[15] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "Shop:", -1)),
                _createElementVNode("span", _hoisted_47, _toDisplayString(tire.shop), 1)
              ]),
              _createElementVNode("div", _hoisted_48, [
                _cache[16] || (_cache[16] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "Invoice:", -1)),
                _createElementVNode("span", _hoisted_49, _toDisplayString(tire.invoice_number), 1)
              ]),
              _createElementVNode("div", _hoisted_50, [
                _cache[17] || (_cache[17] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "Submitted:", -1)),
                _createElementVNode("span", _hoisted_51, _toDisplayString(formatDate(tire.created_at)), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("button", {
                onClick: ($event: any) => (_ctx.$emit('view', tire)),
                class: "flex-1 inline-flex items-center justify-center gap-1.5 px-3 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg text-sm font-medium transition-colors"
              }, _cache[18] || (_cache[18] = [
                _createElementVNode("svg", {
                  class: "w-4 h-4",
                  fill: "currentColor",
                  viewBox: "0 0 20 20"
                }, [
                  _createElementVNode("path", { d: "M10 12a2 2 0 100-4 2 2 0 000 4z" }),
                  _createElementVNode("path", {
                    "fill-rule": "evenodd",
                    d: "M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z",
                    "clip-rule": "evenodd"
                  })
                ], -1),
                _createTextVNode(" View ")
              ]), 8, _hoisted_53),
              _createElementVNode("button", {
                onClick: ($event: any) => (_ctx.$emit('edit', tire)),
                class: "flex-1 inline-flex items-center justify-center gap-1.5 px-3 py-2 bg-amber-500 hover:bg-amber-600 text-white rounded-lg text-sm font-medium transition-colors"
              }, _cache[19] || (_cache[19] = [
                _createElementVNode("svg", {
                  class: "w-4 h-4",
                  fill: "currentColor",
                  viewBox: "0 0 20 20"
                }, [
                  _createElementVNode("path", { d: "M17.414 2.586a2 2 0 010 2.828L8 14.828 4 16l1.172-4 9.414-9.414a2 2 0 012.828 0z" })
                ], -1),
                _createTextVNode(" Edit ")
              ]), 8, _hoisted_54),
              (tire.approval_status === 'pending')
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: ($event: any) => (_ctx.$emit('approve', tire)),
                    class: "flex-1 inline-flex items-center justify-center gap-1.5 px-3 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg text-sm font-medium transition-colors"
                  }, _cache[20] || (_cache[20] = [
                    _createElementVNode("svg", {
                      class: "w-4 h-4",
                      fill: "currentColor",
                      viewBox: "0 0 20 20"
                    }, [
                      _createElementVNode("path", {
                        "fill-rule": "evenodd",
                        d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
                        "clip-rule": "evenodd"
                      })
                    ], -1),
                    _createTextVNode(" Approve ")
                  ]), 8, _hoisted_55))
                : _createCommentVNode("", true),
              (tire.approval_status === 'pending')
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    onClick: ($event: any) => (_ctx.$emit('reject', tire)),
                    class: "flex-1 inline-flex items-center justify-center gap-1.5 px-3 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg text-sm font-medium transition-colors"
                  }, _cache[21] || (_cache[21] = [
                    _createElementVNode("svg", {
                      class: "w-4 h-4",
                      fill: "currentColor",
                      viewBox: "0 0 20 20"
                    }, [
                      _createElementVNode("path", {
                        "fill-rule": "evenodd",
                        d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                        "clip-rule": "evenodd"
                      })
                    ], -1),
                    _createTextVNode(" Reject ")
                  ]), 8, _hoisted_56))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                onClick: ($event: any) => (_ctx.$emit('delete', tire)),
                class: "flex-1 inline-flex items-center justify-center gap-1.5 px-3 py-2 border border-red-300 dark:border-red-600 text-red-700 dark:text-red-400 bg-white dark:bg-black hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg text-sm font-medium transition-colors"
              }, _cache[22] || (_cache[22] = [
                _createElementVNode("svg", {
                  class: "w-4 h-4",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                  })
                ], -1),
                _createTextVNode(" Delete ")
              ]), 8, _hoisted_57)
            ])
          ]))
        }), 128))
      ])
    ])
  ], 64))
}
}

})